export const LocationIcon = () => (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 14S4 9.333 4 6a4 4 0 0 1 8 0c0 3.333-4 8-4 8Zm0-9.333a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666v0Z"
            stroke="#7F8898"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
